import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { PRODUCT_KEYS } from '@src/types/productType';
import Spinner from '@components/molecules/Spinner';

import { CallGetAllProducts, CallPutProductsRecommend } from '@src/library/request/callProduct';
import CommonCheckBox from '@src/components/molecules/checkBox/CheckBox';
import ScrollTopBtn from '@src/components/molecules/ScrollTopBtn';

const Recommend = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const storeId = searchParams.get('storeID');

  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState({ products: [] });

  const [selected, setSelected] = useState([]);

  const {
    data: products,
    refetch,
    isFetched,
  } = useQuery([PRODUCT_KEYS.PRODUCTRECOMMEND, storeId], {
    cacheTime: 0,
    enabled: true,
    queryFn: async () => {
      try {
        setLoading(true);
        const res = await CallGetAllProducts(storeId);
        if (res.data) {
          const currentData = res.data as any;

          setItem(currentData);
          setSelected(currentData.recommend.products);
        }

        return res.data as any;
      } catch (error) {
        console.log('error', error);
        throw error;
      } finally {
        setLoading(false);
      }
    },
  });

  const saveProducts = async () => {
    setLoading(true);
    const categories: any = [];

    item.products.forEach((category) => {
      const product: any = [];

      category.products.forEach((current: any) => {
        product.push({
          productID: current.productID,
          recommend: selected.some((e) => e.productID === current.productID) ? 1 : 0,
        });
      });

      categories.push({ categoryID: category.categoryID, product });
    });

    try {
      const res = await CallPutProductsRecommend(storeId, { categories });
      if (res.result.code === 1) {
        window.alert(`추천 메뉴 설정이 완료되었습니다.`);
        navigate(`/product/list?tab=recommend&storeID=${storeId}`);
      }
    } catch (error) {
      console.log('error', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <article id="mArticle" className="art-product">
      <div className="box-recommend">
        <p className="desc-info">
          최대 10개까지 설정 가능하며 메뉴 이미지가 등록된 메뉴만 추천 메뉴로 설정하실 수 있습니다.
          <br />
          이미지 등록은
          <button
            type="button"
            onClick={() => {
              navigate(`/product/list?storeID=${storeId}`);
            }}
          >
            [메뉴관리]
          </button>
          에서 등록해 주세요.
        </p>
      </div>
      <ul className="list-recommend">
        {isFetched &&
          item.products.map((v, idx) => {
            return v.products.map((p: any, num: number) => {
              if (!p.imageUrl) return null;
              let isChecked = false;
              if (selected.some((z) => z.productID === p.productID)) isChecked = true;

              return (
                <li key={`recommend-${num}`}>
                  <img src={p.imageUrl} width="60" height="60" className="thumb-recommend" alt="" />
                  <div className="info-recommend">
                    <strong className="tit-subject">{p.name}</strong>
                    <span className="txt-story">{p.productDescription}</span>
                  </div>
                  <label className="inp-check">
                    <CommonCheckBox
                      id={`recommend-${p.productID}`}
                      onChange={() => {
                        if (selected.length >= 10) {
                          window.alert('추천 메뉴는 최대 10개까지 설정 가능합니다.');
                          return;
                        }
                        if (isChecked) {
                          setSelected((prev) => {
                            return prev.filter((i) => i.productID !== p.productID);
                          });
                        } else {
                          setSelected((prev) => {
                            return prev.concat(p);
                          });
                        }
                      }}
                      value={isChecked}
                    />
                  </label>
                </li>
              );
            });
          })}
      </ul>

      <div className="fixedBtnGroup">
        <button type="button" id="btnSubmit" className="btnDone" onClick={saveProducts}>
          저장
        </button>
      </div>
      <ScrollTopBtn />
      <Spinner show={loading} />
    </article>
  );
};

export default Recommend;
